/**
 * assets/popup-search.js
 * -----------------------
 * Opens #popup-search-modal every time the homepage is loaded (a normal
 * navigation, refresh, or new tab to "/" all count as a load). This is
 * intentionally NOT tied to sessionStorage/localStorage — it fires on
 * every page load of the homepage template, full stop.
 */
document.addEventListener('DOMContentLoaded', function () {
  var modal = document.getElementById('popup-search-modal');
  if (!modal) return;

  function openModal() {
    modal.hidden = false;
    document.body.classList.add('popup-search-open');

    var input = modal.querySelector('input[type="search"]');
    if (input) {
      // Slight delay so the modal is visible before focus/keyboard opens
      setTimeout(function () {
        input.focus();
      }, 50);
    }
  }

  function closeModal() {
    modal.hidden = true;
    document.body.classList.remove('popup-search-open');
  }

  // Always show on load — this snippet is only rendered on the homepage
  // template (see the {% if request.page_type == 'index' %} check in
  // theme.liquid), so no extra page check is needed here.
  openModal();

  var closeBtn = modal.querySelector('.popup-search-close');
  if (closeBtn) {
    closeBtn.addEventListener('click', closeModal);
  }

  modal.addEventListener('click', function (event) {
    if (event.target === modal) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !modal.hidden) {
      closeModal();
    }
  });
});
